module.exports = __webpack_public_path__ + "img/img10.076e7e4b.png";